import React from 'react';
import { Alert as ChakraAlert, AlertDescription, AlertIcon, AlertTitle, Box, HStack, Link, VStack, } from '@chakra-ui/react';
import { isNil } from 'ramda';
import { RenderIf } from '../RenderIf/RenderIf';
import { useTokens } from '../../../context/TokenProvider';
import CloseIcon from '../../icons/CloseIcon/CloseIcon';
export const Alert = ({ status, icon, title, children, link, linkHref, onClose, ...rest }) => {
    const tokens = useTokens();
    return (React.createElement(ChakraAlert, { variant: status, status: status, ...rest },
        React.createElement(VStack, { gap: tokens.Spacing02 },
            React.createElement(HStack, { alignSelf: "start", gap: 0 },
                React.createElement(RenderIf, { condition: icon === true },
                    React.createElement(AlertIcon, { "data-testid": "alert-icon" })),
                React.createElement(Box, null,
                    React.createElement(RenderIf, { condition: !isNil(title) },
                        React.createElement(AlertTitle, { "data-testid": "alert_title" }, title)))),
            React.createElement(Box, { alignSelf: "start" },
                React.createElement(AlertDescription, { "data-testid": "alert_description" }, children)),
            React.createElement(RenderIf, { condition: !isNil(link) },
                React.createElement(Box, null,
                    React.createElement(Link, { "data-testid": "alert-link", variant: `alert-${status}`, href: linkHref }, link)))),
        React.createElement(RenderIf, { condition: !isNil(onClose) },
            React.createElement(Box, { position: "absolute", right: tokens.Spacing05, top: tokens.Spacing05 },
                React.createElement("button", { type: "button", "aria-label": "Close alert", onClick: onClose, "data-testid": "alert-close" },
                    React.createElement(CloseIcon, null))))));
};
